export class Image {
	public id?: number;

	constructor(
		public content: string
	) {
	}
}